<template>
  <div class="layout">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="dark" active-name="1">
          <div class="layout-logo">
            <img src="/static/brand-logo.png" alt="">
            <div>2020舞蹈工作室后台管理系统</div>
          </div>
          <div class="layout-nav">
            <MenuItem name="1">
            <Icon type="ios-contact" />
            {{userInfo.name || ''}}
            </MenuItem>
            <MenuItem name="2" @click.native="showModal">
            <Icon type="md-lock" />
            修改密码
            </MenuItem>
            <MenuItem name="3" @click.native="logout">
            <Icon type="md-exit" />
            退出
            </MenuItem>
          </div>
        </Menu>
      </Header>
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <Menu :active-name="activeName" theme="light" width="auto" :open-names="openNames" @on-select="showMenu">
            <Submenu v-if="userInfo.type!='SUPER_ADMIN'" name="1">
              <template slot="title">
                <Icon type="ios-book"></Icon>
                课程管理
              </template>
              <MenuItem name="courseManage" to="/courseManage">课程管理</MenuItem>
              <MenuItem name="stopManage" to="/stopManage">停卡申请</MenuItem>
            </Submenu>
            <Submenu v-if="userInfo.type=='SUPER_ADMIN'" name="4">
              <template slot="title">
                <Icon type="md-home"></Icon>
                分店管理
              </template>
              <MenuItem name="branchManage" to="/branchManage">分店管理</MenuItem>
            </Submenu>
            <Submenu name="8">
              <template slot="title">
                <Icon type="md-contacts" />
                班级管理
              </template>
              <MenuItem name="classManage" to="/classManage">班级管理</MenuItem>
            </Submenu>
            <Submenu name="5">
              <template slot="title">
                <Icon type="md-person" />
                用户管理
              </template>
              <MenuItem name="userManage" to="/userManage">用户管理</MenuItem>
            </Submenu>
            <Submenu name="9">
              <template slot="title">
                <Icon type="ios-analytics" />
                统计管理
              </template>
              <MenuItem name="stuCount" to="/stuCount">学员统计</MenuItem>
              <MenuItem name="teacherCount" to="/teacherCount">教师统计</MenuItem>
              <MenuItem name="cardCount" to="/cardCount">学员卡统计</MenuItem>
            </Submenu>
            <Submenu v-if="userInfo.type!='SUPER_ADMIN'" name="6">
              <template slot="title">
                <Icon type="ios-paper"></Icon>
                公告管理
              </template>
              <MenuItem name="noticeManage" to="/noticeManage">公告管理</MenuItem>
            </Submenu>
            <Submenu v-if="userInfo.type!='SUPER_ADMIN'" name="7">
              <template slot="title">
                <Icon type="md-images"></Icon>
                广告位管理
              </template>
              <MenuItem name="bannerManage" to="/bannerManage">广告位管理</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <Layout :style="{padding: '0 24px 24px'}">
          <Breadcrumb :style="{margin: '24px 0'}">
            <BreadcrumbItem>{{breadName}}</BreadcrumbItem>
          </Breadcrumb>
          <Content :style="{padding: '24px', minHeight: '280px', height:'83vh', overflow: 'auto', background: '#fff'}">
            <router-view></router-view>
          </Content>
        </Layout>
      </Layout>
    </Layout>
    <Modal v-model="modal" :title="title" footer-hide>
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="旧密码" prop="oldPassword">
          <Input v-model="formValidate.oldPassword " placeholder="请输入旧密码" type="password"></Input>
        </FormItem>
        <FormItem label="新密码" prop="newPassword">
          <Input v-model="formValidate.newPassword " placeholder="请输入新密码" type="password"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')" :loading="addLoading">确认</Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<style lang="less" scoped>
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.layout-logo {
  height: 40px;
  float: left;
  position: relative;
  top: 12px;
  left: 20px;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: white;
  font-weight: 500;

  img {
    width: 40px;
    height: 40px;
    display: block;
    margin-right: 6px;
  }
}

.layout-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
<script>
import moment from "moment";
import globalData from "../service/globalData";
import { Logout } from "../service/login";
import md5 from "js-md5";
import * as account from "../service/account";
export default {
  data() {
    return {
      isCollapsed: false,
      openNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      activeName: "userManage",
      breadName: "用户管理",
      curPath: "",
      userInfo: {},
      modal: false,
      title: "修改密码",
      addLoading: false,
      formValidate: {
        newPassword: "",
        oldPassword: "",
      },
      ruleValidate: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    globalData.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  },
  mounted() {
    this.activeName = this.$route.name;
    console.log(this.$route.name, "routeName");
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
      console.log(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    },
    logout() {
      // 删除缓存，跳转到登录页
      Logout().then(
        (res) => {
          console.log(res, "logout");
          sessionStorage.clear();
          globalData.sessionKey = "";
          // globalData.userInfo = {};
          this.$router.push({
            path: "/",
          });
        },
        (err) => {
          this.$Message.error(
            err.response.data.message || "退出登录失败!"
          );
        }
      );
    },
    showMenu(e) {
      console.log(e, "showmenu");
      switch (e) {
        case "userManage":
          this.breadName = "用户管理";
          break;
        case "branchManage":
          this.breadName = "分店管理";
          break;
        case "noticeManage":
          this.breadName = "公告管理";
          break;
        case "bannerManage":
          this.breadName = "广告位管理";
          break;
        case "courseManage":
          this.breadName = "课程管理";
          break;
        case "stopManage":
          this.breadName = "停卡申请";
          break;
        case "classManage":
          this.breadName = "班级管理";
          break;
        case "stuCount":
          this.breadName = "学员统计";
          break;
        case "teacherCount":
          this.breadName = "教师统计";
          break;
				case "cardCount":
					this.breadName = "学员卡统计";
        default:
          return;
      }
    },

    showModal() {
      this.modal = true;
      this.handleReset("formValidate");
    },

    handleReset(name) {
      this.$refs[name].resetFields();
    },

    // 修改密码
    handleSubmit(name) {
      if (this.addLoading) return;

      this.formValidate.oldPassword = md5(this.formValidate.oldPassword);
      this.formValidate.newPassword = md5(this.formValidate.newPassword);

      this.$refs[name].validate((valid) => {
        this.addLoading = true;
        account.changePass(this.formValidate).then(
          (res) => {
            this.$Message.success("密码修改成功!");
            this.modal = false;
            this.addLoading = false;
          },
          (err) => {
            this.$Message.error(
              err.response.data.message || "密码修改失败"
            );
            this.addLoading = false;
            this.modal = false;
          }
        );
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/index.vue